var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"region-chart-container"},[_c('svg',{ref:"svg",staticClass:"overflow-visible text-gray-500 fill-current",attrs:{"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }